import { Controller } from "stimulus"

export default class extends Controller {
  submitToAltPath(event) {
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData(this.element);
    const queryString = new URLSearchParams(data).toString();
    const [altPath, altPathQueryString] = event.target.dataset.altPath.split('?');
    const fullQueryString = [queryString, altPathQueryString].join('&');
    new Fakturan.OverlayForm(null, { url: altPath + '?' + fullQueryString, size: '10', outerclick: false });
  }
}